/**
 * MINISOLO PREVIEW - Canvas-basierte Live-Vorschau
 * Zeigt personalisierte Mini-Blumentöpfe mit 3 Textzeilen und 6 Schriftarten
 * Varianten: Rosa, Türkis, Weiß, Braun
 */

const MiniSoloPreview = {
  // ========================================
  // KONFIGURATION
  // ========================================
  config: {
    // Vorschaubilder für jede Variante
    variantImages: {
      'Rosa': 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Gemini_Generated_Image_l13udol13udol13u.png?v=1765785858',
      'Türkis': 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Gemini_Generated_Image_cu1yiqcu1yiqcu1y_1.png?v=1765785859',
      'Weiß': 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Gemini_Generated_Image_y5k15y5k15y5k15y.png?v=1765785859',
      'Braun': 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Gemini_Generated_Image_48g2z048g2z048g2.png?v=1765785858'
    },

    // Default-Bild (falls keine Variante ausgewählt)
    defaultImage: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Gemini_Generated_Image_l13udol13udol13u.png?v=1765785858',

    // Canvas-Dimensionen
    canvasWidth: 800,
    canvasHeight: 800,

    // Schriftarten-Konfiguration
    fontConfig: {
      'Pixie Ring': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Pixie_Ring_Regular.ttf?v=1761954704',
        name: 'Pixie Ring'
      },
      'Dreaming Outloud': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/dreaming-outloud-allcaps-regular.ttf?v=1761954704',
        name: 'Dreaming Outloud'
      },
      'Montserrat': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Montserrat-VariableFont_wght.ttf?v=1761954705',
        name: 'Montserrat'
      },
      'Allura': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/Allura-Regular.ttf?v=1761954704',
        name: 'Allura'
      },
      'Bebas Neue': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/BebasNeue-Regular.ttf?v=1761954704',
        name: 'Bebas Neue'
      },
      'Amatic SC': {
        url: 'https://cdn.shopify.com/s/files/1/0696/9494/7595/files/AmaticSC-Regular.ttf?v=1761954704',
        name: 'Amatic SC'
      }
    },

    // Text-Positionen (3 Zeilen, zentriert auf dem Topf)
    // curve: Krümmungsstärke (0 = gerade, höher = stärker gebogen nach unten)
    textConfig: {
      line1: { x: 400, y: 450, fontSize: 48, curve: 0.035 },
      line2: { x: 400, y: 510, fontSize: 48, curve: 0.028 },
      line3: { x: 400, y: 570, fontSize: 48, curve: 0.022 },
      color: '#5a4a3a' // Braun/Dunkelgrau für Gravur-Effekt
    }
  },

  // Interner State
  canvas: null,
  ctx: null,
  images: {},
  fontsLoaded: false,
  isRendering: false,
  currentVariant: 'Rosa',
  currentFont: 'Bebas Neue',

  /**
   * Initialisierung
   */
  init() {
    this.canvas = document.getElementById('minisolo-preview-canvas');
    if (!this.canvas) {
      console.error('MiniSolo: Canvas element not found');
      return;
    }

    this.ctx = this.canvas.getContext('2d');
    this.setupEventListeners();
    this.loadFonts();
    this.preloadImages();
    this.setupCartIntegration();
    this.setupTopffarbenSync();

    console.log('MiniSoloPreview initialized');
  },

  /**
   * Event Listeners einrichten
   */
  setupEventListeners() {
    // Vorschau-Button
    const previewBtn = document.getElementById('minisolo-preview-btn');
    if (previewBtn) {
      previewBtn.addEventListener('click', () => this.openPreview());
    }

    // Modal schließen
    const closeBtn = document.querySelector('.minisolo-preview-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closePreview());
    }

    // Modal-Hintergrund klicken
    const modal = document.getElementById('minisolo-preview-modal');
    if (modal) {
      modal.addEventListener('click', (e) => {
        if (e.target.id === 'minisolo-preview-modal') {
          this.closePreview();
        }
      });
    }

    // ESC-Taste
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closePreview();
      }
    });

    // Schriftart-Auswahl via Radio Buttons
    const fontRadios = document.querySelectorAll('input[name="minisolo-font-choice"]');
    fontRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        const hiddenFont = document.getElementById('minisolo-font');
        if (hiddenFont) {
          hiddenFont.value = e.target.value;
          this.currentFont = e.target.value;
          console.log('MiniSolo: Font changed to:', this.currentFont);
        }
      });
    });

    // Topffarbe-Auswahl via Radio Buttons
    const topffarbenRadios = document.querySelectorAll('input[name="minisolo-topffarbe"]');
    topffarbenRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.currentVariant = e.target.value;
        console.log('MiniSolo: Topffarbe changed to:', this.currentVariant);
        this.syncShopifyVariant(e.target.value);
        this.syncFieldsToCart();
      });
    });
  },

  /**
   * Topffarben-Synchronisation mit Shopify-Varianten einrichten
   */
  setupTopffarbenSync() {
    // Initial: Erkennen welche Topffarbe ausgewählt ist
    const selectedTopffarbe = document.querySelector('input[name="minisolo-topffarbe"]:checked');
    if (selectedTopffarbe) {
      this.currentVariant = selectedTopffarbe.value;
      // Shopify-Variante synchronisieren
      setTimeout(() => this.syncShopifyVariant(this.currentVariant), 100);
    }
  },

  /**
   * Shopify-Variante basierend auf Topffarbe synchronisieren
   */
  syncShopifyVariant(topffarbe) {
    // Methode 1: Versuche das Select-Element zu finden und zu aktualisieren
    const variantSelect = document.querySelector('select[name="options[Topffarbe]"], select[name*="Topffarbe"]');
    if (variantSelect) {
      for (const option of variantSelect.options) {
        if (option.value === topffarbe || option.textContent.trim() === topffarbe) {
          variantSelect.value = option.value;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          console.log('MiniSolo: Shopify variant synced via select');
          return;
        }
      }
    }

    // Methode 2: Versuche Radio-Buttons zu finden
    const variantRadios = document.querySelectorAll('input[type="radio"][name*="option"], input[type="radio"][name*="Topffarbe"]');
    for (const radio of variantRadios) {
      if (radio.value === topffarbe) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        console.log('MiniSolo: Shopify variant synced via radio');
        return;
      }
    }

    // Methode 3: Versuche das versteckte Varianten-ID-Feld zu aktualisieren
    // basierend auf den Produktdaten im DOM
    const productJson = document.querySelector('[data-product-json], script[type="application/json"][data-product-json]');
    if (productJson) {
      try {
        const productData = JSON.parse(productJson.textContent);
        if (productData.variants) {
          for (const variant of productData.variants) {
            if (variant.option1 === topffarbe || variant.title === topffarbe || variant.title.includes(topffarbe)) {
              const variantIdInput = document.querySelector('input[name="id"], select[name="id"]');
              if (variantIdInput) {
                variantIdInput.value = variant.id;
                variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
                console.log('MiniSolo: Shopify variant ID synced:', variant.id);
                return;
              }
            }
          }
        }
      } catch (e) {
        console.log('MiniSolo: Could not parse product JSON');
      }
    }

    console.log('MiniSolo: Could not sync Shopify variant, using properties fallback');
  },

  /**
   * Fonts laden
   */
  async loadFonts() {
    try {
      await document.fonts.ready;

      // Alle Schriftarten laden
      for (const [fontName, fontData] of Object.entries(this.config.fontConfig)) {
        await document.fonts.load(`48px "${fontData.name}"`);
      }

      this.fontsLoaded = true;
      console.log('MiniSolo: Fonts loaded successfully');
    } catch (error) {
      console.error('MiniSolo: Error loading fonts:', error);
      this.fontsLoaded = true;
    }
  },

  /**
   * Alle Variantenbilder vorladen
   */
  preloadImages() {
    for (const [variant, url] of Object.entries(this.config.variantImages)) {
      this.images[variant] = new Image();
      this.images[variant].crossOrigin = 'anonymous';
      this.images[variant].src = url;

      this.images[variant].onload = () => {
        console.log(`MiniSolo: Image loaded for ${variant}`);
      };

      this.images[variant].onerror = () => {
        console.error(`MiniSolo: Failed to load image for ${variant}`);
      };
    }
  },

  /**
   * Formulardaten sammeln
   */
  getFormData() {
    // Schriftart aus Hidden Field oder aus ausgewähltem Radio Button
    const selectedFont = document.querySelector('input[name="minisolo-font-choice"]:checked');
    const fontValue = selectedFont ? selectedFont.value : (document.getElementById('minisolo-font')?.value || 'Bebas Neue');

    // Topffarbe aus Radio Button
    const selectedTopffarbe = document.querySelector('input[name="minisolo-topffarbe"]:checked');
    const topffarbe = selectedTopffarbe ? selectedTopffarbe.value : 'Rosa';

    return {
      line1: document.getElementById('minisolo-line1')?.value || '',
      line2: document.getElementById('minisolo-line2')?.value || '',
      line3: document.getElementById('minisolo-line3')?.value || '',
      font: fontValue,
      topffarbe: topffarbe,
      variant: topffarbe
    };
  },

  /**
   * Vorschau öffnen und rendern
   */
  async openPreview() {
    if (this.isRendering) return;

    const formData = this.getFormData();
    this.currentVariant = formData.topffarbe;

    const modal = document.getElementById('minisolo-preview-modal');

    if (modal) {
      modal.style.display = 'flex';
      await this.renderPreview(formData);
    }
  },

  /**
   * Vorschau schließen
   */
  closePreview() {
    const modal = document.getElementById('minisolo-preview-modal');
    if (modal) {
      modal.style.display = 'none';
    }
  },

  /**
   * Canvas-Vorschau rendern
   */
  async renderPreview(formData) {
    if (this.isRendering) return;
    this.isRendering = true;

    try {
      // Warten auf Fonts
      if (!this.fontsLoaded) {
        await this.loadFonts();
      }

      // Canvas zurücksetzen
      this.ctx.clearRect(0, 0, this.config.canvasWidth, this.config.canvasHeight);

      // 1. Varianten-Bild zeichnen
      const variantImage = this.images[formData.variant];
      if (variantImage && variantImage.complete) {
        this.ctx.drawImage(
          variantImage,
          0, 0,
          this.config.canvasWidth,
          this.config.canvasHeight
        );
      } else {
        // Fallback: Default-Bild laden
        await this.drawFallbackImage();
      }

      // 2. Textzeilen zeichnen
      await this.drawText(formData);

    } catch (error) {
      console.error('MiniSolo: Rendering error:', error);
    } finally {
      this.isRendering = false;
    }
  },

  /**
   * Fallback-Bild zeichnen
   */
  async drawFallbackImage() {
    return new Promise((resolve) => {
      const fallbackImg = new Image();
      fallbackImg.crossOrigin = 'anonymous';

      fallbackImg.onload = () => {
        this.ctx.drawImage(
          fallbackImg,
          0, 0,
          this.config.canvasWidth,
          this.config.canvasHeight
        );
        resolve();
      };

      fallbackImg.onerror = () => {
        console.error('MiniSolo: Failed to load fallback image');
        // Zeichne weißen Hintergrund als Fallback
        this.ctx.fillStyle = '#f5f5f5';
        this.ctx.fillRect(0, 0, this.config.canvasWidth, this.config.canvasHeight);
        resolve();
      };

      fallbackImg.src = this.config.defaultImage;
    });
  },

  /**
   * Text zeichnen (3 Zeilen) mit leichter Krümmung
   */
  async drawText(formData) {
    const textConfig = this.config.textConfig;
    const fontData = this.config.fontConfig[formData.font];
    const fontName = fontData ? fontData.name : 'Bebas Neue';

    // Text-Style setzen
    this.ctx.fillStyle = textConfig.color;

    // Alle 3 Zeilen zeichnen
    const lines = [
      { text: formData.line1, config: textConfig.line1 },
      { text: formData.line2, config: textConfig.line2 },
      { text: formData.line3, config: textConfig.line3 }
    ];

    for (const line of lines) {
      if (line.text) {
        this.ctx.font = `${line.config.fontSize}px "${fontName}"`;
        this.drawCurvedText(line.text, line.config.x, line.config.y, line.config.curve || 0);
      }
    }
  },

  /**
   * Text mit leichter Krümmung zeichnen (folgt der Topf-Form)
   * @param {string} text - Der zu zeichnende Text
   * @param {number} centerX - Mittelpunkt X
   * @param {number} centerY - Basis Y-Position
   * @param {number} curveStrength - Stärke der Krümmung (0 = gerade)
   */
  drawCurvedText(text, centerX, centerY, curveStrength) {
    if (!text || curveStrength === 0) {
      // Kein Text oder keine Krümmung - normal zeichnen
      this.ctx.textAlign = 'center';
      this.ctx.textBaseline = 'middle';
      this.ctx.fillText(text, centerX, centerY);
      return;
    }

    // Textbreite messen
    const totalWidth = this.ctx.measureText(text).width;

    // Startposition (links vom Zentrum)
    let currentX = centerX - totalWidth / 2;

    // Jeden Buchstaben einzeln zeichnen mit Y-Offset basierend auf Position
    this.ctx.textAlign = 'left';
    this.ctx.textBaseline = 'middle';

    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const charWidth = this.ctx.measureText(char).width;

      // Position relativ zum Zentrum (-0.5 bis 0.5)
      const charCenterX = currentX + charWidth / 2;
      const relativePos = (charCenterX - centerX) / (totalWidth / 2);

      // Parabel-Kurve: y = -curveStrength * x^2 * totalWidth
      // Der Text biegt sich nach unten (Mitte höher, Ränder tiefer)
      const yOffset = -curveStrength * relativePos * relativePos * totalWidth;

      // Buchstaben zeichnen
      this.ctx.fillText(char, currentX, centerY + yOffset);

      // Zur nächsten Position
      currentX += charWidth;
    }
  },

  /**
   * Warenkorb-Integration
   */
  setupCartIntegration() {
    // Hidden Fields ins Product Form einfügen
    const productForm = document.querySelector('form[action*="/cart/add"]');

    if (productForm) {
      // Sicherstellen dass Hidden Fields im Form sind
      const hiddenFields = [
        document.getElementById('minisolo-hidden-topffarbe'),
        document.getElementById('minisolo-hidden-line1'),
        document.getElementById('minisolo-hidden-line2'),
        document.getElementById('minisolo-hidden-line3'),
        document.getElementById('minisolo-hidden-font')
      ];

      hiddenFields.forEach(field => {
        if (field && !productForm.contains(field)) {
          productForm.appendChild(field);
        }
      });

      console.log('MiniSolo: Hidden fields moved to product form');
    }

    // Formularfelder synchronisieren
    const fields = [
      'minisolo-line1',
      'minisolo-line2',
      'minisolo-line3',
      'minisolo-font'
    ];

    fields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field) {
        field.addEventListener('change', () => this.syncFieldsToCart());
        field.addEventListener('input', () => this.syncFieldsToCart());
        field.addEventListener('blur', () => this.syncFieldsToCart());
      }
    });

    // Schriftart-Auswahl synchronisieren
    document.querySelectorAll('input[name="minisolo-font-choice"]').forEach(radio => {
      radio.addEventListener('change', () => this.syncFieldsToCart());
    });

    // Topffarbe-Auswahl synchronisieren
    document.querySelectorAll('input[name="minisolo-topffarbe"]').forEach(radio => {
      radio.addEventListener('change', () => this.syncFieldsToCart());
    });

    // Bei Form Submit synchronisieren
    if (productForm) {
      productForm.addEventListener('submit', () => {
        this.syncFieldsToCart();
      });
    }

    // Initial sync
    setTimeout(() => this.syncFieldsToCart(), 500);

    console.log('MiniSolo: Cart integration setup complete');
  },

  /**
   * Felder zum Warenkorb synchronisieren
   */
  syncFieldsToCart() {
    const formData = this.getFormData();

    const hiddenFields = {
      'minisolo-hidden-topffarbe': formData.topffarbe,
      'minisolo-hidden-line1': formData.line1,
      'minisolo-hidden-line2': formData.line2,
      'minisolo-hidden-line3': formData.line3,
      'minisolo-hidden-font': formData.font
    };

    for (const [id, value] of Object.entries(hiddenFields)) {
      const field = document.getElementById(id);
      if (field) {
        field.value = value;
      }
    }
  }
};

// Auto-Initialisierung
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => MiniSoloPreview.init());
} else {
  MiniSoloPreview.init();
}
